import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useReducer,
} from 'react';
import { Linking, Text, View } from 'react-native';
import { AsYouType }           from "libphonenumber-js";
// import { useNavigation }       from '@react-navigation/native';

import Col                     from '~/layouts/Col';
import Row                     from '~/layouts/Row';

import SolidButton             from "~/components/Buttons/SolidButton/";
import IconButton              from "~/components/Buttons/IconButton";
import Heading                 from "~/components/Heading/index.web";
import useTwilio               from "~/hooks/useTwilio";

import Engage                  from "~/services/engage";
import palette                 from "~/styles/palette";

const initialState = {
  number: '',
  participant: null,
};

const dialReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch(type) {
    case 'ADD_NUM': {
      return {
        ...state,
        number: `${state.number}${payload}`,
      };
    }

    case 'REMOVE_NUM': {
      return {
        ...state,
        number: state.number.slice(0, -1),
      };
    }

    case 'CLEAR_NUM': {
      return {
        ...state,
        number: '',
      };
    }

    case 'FOUND_PARTICIPANT': {
      return {
        ...state,
        participant: payload,
      };
    }

    case 'CLEAR_PARTICIPANT': {
      return {
        ...state,
        participant: null,
      };
    }

    default: {
      return state;
    }
  }
};


const Dialer = () => {
  const { startCall, endCall, activeCall } = useTwilio();

  const [dialState, dialDispatch] = useReducer(dialReducer, initialState);

  const onCallVoip = useCallback(() => {
    if (!activeCall) {
      startCall(dialState.number, dialState.participant);

      // navigation.navigate("Modal", {
      //   screen: "ActiveCall",
      // });
    } else {
      endCall();
    }
  }, [activeCall, dialState]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (dialState.number.length > 9) {
        Engage.getParticipantByPhone({
          phone: dialState.number,
        }).then((res) => {
          dialDispatch({ type: 'FOUND_PARTICIPANT', payload: res.response });
        });
      }
    }, 800);

    return () => {
      clearTimeout(timeout);
      dialDispatch({ type: 'CLEAR_PARTICIPANT' });
    };

  }, [dialState.number]);

  const numberButtons = useMemo(() => {
    const numbers = new Array(9).fill(0);

    const onPress = (number) => () => dialDispatch({ type: 'ADD_NUM', payload: number });

    return numbers.map((_, i) => {
      return (
        <Col ml={8} mr={8} mt={8} mb={8} maxWidth={80} key={i}>
          <SolidButton
            label={`${i + 1}`}
            color={palette.light_grey}
            border
            onPress={onPress(i + 1)}
            width={80}
            labelStyle={{ fontSize: 32 }}
            style={{ height: 80, borderRadius: 80 }}
          />
        </Col>
      );
    });
  }, [dialDispatch]);

  const numberRows = useMemo(() => {
    return (
      <Row pl={32} pr={32} centered>
        <Col centered>
          <Row center>
            {numberButtons.slice(0, 3)}
          </Row>

          <Row center>
            {numberButtons.slice(3, 6)}
          </Row>

          <Row center>
            {numberButtons.slice(6, 9)}
          </Row>

          <Row center>
            <Col ml={8} mr={8} mt={8} mb={8} maxWidth={80}>
              <IconButton
                iconName="x"
                iconSize={32}
                onPress={() => dialDispatch({ type: 'CLEAR_NUM' })}
                color={palette.light_grey}
                width={80}
                mr={0}
                ml={0}
                style={{ height: 80 }}
              />
            </Col>

            <Col ml={8} mr={8} mt={8} mb={8} maxWidth={80}>
              <SolidButton
                label="0"
                color={palette.light_grey}
                onPress={() => dialDispatch({ type: 'ADD_NUM', payload: 0  })}
                width={80}
                labelStyle={{ fontSize: 32 }}
                style={{ height: 80, borderRadius: 80 }}
              />
            </Col>

            <Col ml={8} mr={8} mt={8} mb={8} maxWidth={80}>
              {
                dialState.number.length > 0
                  ? (
                    <IconButton
                      onPress={() => dialDispatch({ type: 'REMOVE_NUM' })}
                      iconName="chevron-left"
                      iconSize={32}
                      color={palette.light_grey}
                      width={80}
                      mr={0}
                      ml={0}
                      style={{ height: 80 }}
                    />
                  ) : (
                    <IconButton
                      onPress={() => dialDispatch({ type: 'ADD_NUM', payload: '+' })}
                      iconName="plus"
                      iconSize={32}
                      color={palette.light_grey}
                      width={80}
                      mr={0}
                      ml={0}
                      style={{ height: 80 }}
                    />
                  )
              }
            </Col>
          </Row>

          <Row center mb={32}>
            <Col ml={8} mr={8} mt={8} mb={8} maxWidth={80}>
            </Col>

            <Col ml={8} mr={8} mt={8} mb={8} maxWidth={80}>
              <IconButton
                iconName={!activeCall ? "phone" : "phone" }
                iconSize={32}
                color={activeCall ? palette.danger : palette.success}
                onPress={onCallVoip}
                width={80}
                mr={0}
                ml={0}
                style={[
                  { height: 80 },
                  !!activeCall && {
                    transform: [
                      {
                        rotateZ: "135deg",
                      },
                    ],
                  }]}
              />
            </Col>

            <Col ml={8} mr={8} mt={8} mb={8} maxWidth={80}>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }, [numberButtons, dialState, activeCall, onCallVoip]);

  return (
    <Row mt={64} style={{ maxHeight: '70%' }}>
      <Col centered pt={64}>
        <View style={{ alignItems: 'center', height: '15%' }}>
          {
            dialState.number.length > 0
              ? <Heading size={2}>{new AsYouType({ defaultCallingCode: '1' }).input(dialState.number)}</Heading>
              : <Heading size={2} color={palette.grey}>Enter a phone number</Heading>
          }

          {
            (dialState.participant && dialState.participant.last_activity_at)
              ? <Heading size={4}>{dialState.participant.name}</Heading>
              : null
          }
        </View>

        <Row center mt={64}>
          <Col>
            {numberRows}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default function DialerPanel() {
  return (
    <View style={{ height: '100%', paddingTop: '30%' }}>
      <Dialer />
    </View>
  );
}
